import Datagent                              from 'datagent';
import {respondData, requestHandle, setYear} from '../utils';
import Fecha                                 from '../utils/type/Fecha';
import {defaults}                            from 'datagent/src/utils';

const {filter, format, getField, awaitTo} = Datagent.Hooks;

export const DateFormat = Fecha.format('YYYY-MM-DD HH:mm:ss');
export const DateParse  = Fecha.parse('YYYY-MM-DD HH:mm:ss');

const name = 'csrScore';
const Model = Datagent.Model({
    name,
    fields : {
        // 'title'               : {type: String, default: ''},//标题
        // 'is_confirm'          : {type: String, default: ''}, //已读标记  0-未确认 1-收录 2-排除
        // 'sentiment_new'       : {type: String, default: ''}, // 情感类型 负面"(默认)， "正面"
        // 'industryId'          : {type: String, default: ''}, //行业id
        // 'secondTargetName'    : {type: String, default: ''}, // 舆情类型
        // 'source'              : {type: String, default: ''}, // 数据来源
        // 'postTime'            : {type: Fecha, default: ''}, // 年份
        'industryList'        : { type: Array, default: [] },//行业列表，默认为[]
    },
    methods: {
      fetch(params, opts){
          const { origin } = defaults(opts);
          const { type, ...query } = params;
          if(typeof type === 'undefined') throw new Error('The type params must be have! use "scoreRank" or "scoreHistoryRank"')
          return this.remote(origin).get(`${this._url}/${type}`, query);
      },
      export(params, opts) {
        const { origin } = defaults(opts);
        const { type, ...query } = params;
        if(typeof type === 'undefined') throw new Error('The type params must be have! use "scoreRank" or "scoreHistoryRank"')
        return this.remote(origin).get(`${this._url}/${type}/export`, query);
      },
    },
    hooks  : {
        ...Datagent.mapSendHook([format()]),
        fetch              : {after: [respondData(), requestHandle(), getField('data', format())]},
        SearchPublicSentiment : {after: [respondData(), requestHandle(), getField('data', format())]},
        getSecondTargetName: {after: [respondData(), requestHandle(), getField('data', format())]},
        find               : {after: [respondData(), requestHandle(), format()]},
        export               : {after: [respondData(), requestHandle()]}
    }
});

Model.ModelName   = name;
export default Model;
